(function() {
  var settings = window.theme && theme.settings ? theme.settings : {};
  if (settings.nestedAddonsIntercept !== true) return;

  var addonConfigEl = document.getElementById('um-addon-config-json');
  if (!addonConfigEl) return;

  var productCacheByHandle = new Map();
  var interceptLock = false;
  var DEBUG_STORAGE_KEY = 'um_nested_addons_debug';
  var LEGACY_IO_SIGNAL_KEYS = ['properties[_io_parent_order_group]', 'properties[_io_field_name]'];

  function isDebugEnabled() {
    try {
      if (window.location && /(?:\?|&)um_nested_debug=1(?:&|$)/.test(window.location.search)) {
        return true;
      }
    } catch (_) {}
    try {
      return window.localStorage && window.localStorage.getItem(DEBUG_STORAGE_KEY) === '1';
    } catch (_) {
      return false;
    }
  }

  function logDebug() {
    if (!isDebugEnabled() || !window.console || !console.log) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[UM Nested Addons]');
    console.log.apply(console, args);
  }

  function emitNestedStatus(status, meta) {
    try {
      document.dispatchEvent(new CustomEvent('um:nested-atc-result', {
        detail: Object.assign({ status: String(status || '') }, meta || {})
      }));
    } catch (_) {}
  }

  function isCartAddUrl(url) {
    return /\/cart\/add(?:\.js)?(?:[?#]|$)/.test(String(url || ''));
  }

  function bodyToText(body) {
    if (body == null) return '';
    if (typeof body === 'string') return body;
    if (body instanceof URLSearchParams) return body.toString();
    if (body instanceof FormData) {
      var pairs = [];
      body.forEach(function(value, key) {
        pairs.push(String(key) + '=' + String(value));
      });
      return pairs.join('&');
    }
    try {
      return JSON.stringify(body);
    } catch (_) {
      return '';
    }
  }

  function decodeBodyText(text) {
    var raw = String(text || '').replace(/\+/g, ' ');
    try {
      return decodeURIComponent(raw);
    } catch (_) {
      return raw;
    }
  }

  function isLegacyIoChildAddRequest(url, body) {
    if (!isCartAddUrl(url)) return false;
    var bodyText = decodeBodyText(bodyToText(body));
    if (!bodyText) return false;

    var hasLegacySignals = LEGACY_IO_SIGNAL_KEYS.every(function(key) {
      return bodyText.indexOf(key) !== -1;
    });
    if (!hasLegacySignals) return false;

    // Never block native nested requests.
    if (bodyText.indexOf('parent_id') !== -1 || bodyText.indexOf('parent_line_key') !== -1) {
      return false;
    }
    return true;
  }

  function installLegacyIoWriterGuard() {
    // Guard fetch-based legacy writer calls.
    var originalFetch = window.fetch;
    if (typeof originalFetch === 'function') {
      window.fetch = function(resource, config) {
        var url = typeof resource === 'string' ? resource : (resource && resource.url ? resource.url : '');
        var cfg = config || {};
        if (isLegacyIoChildAddRequest(url, cfg.body)) {
          logDebug('Blocked legacy IO child add (fetch).', { url: url, body: bodyToText(cfg.body) });
          emitNestedStatus('blocked_legacy_io_child_add', { transport: 'fetch', url: url });
          return originalFetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js', {
            method: 'GET',
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json' }
          });
        }
        return originalFetch.apply(this, arguments);
      };
    }

    // Guard XHR-based legacy writer calls (e.g. customizery.js ajax).
    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function(method, url) {
      this.__umNestedGuard = this.__umNestedGuard || {};
      this.__umNestedGuard.method = String(method || 'GET').toUpperCase();
      this.__umNestedGuard.url = String(url || '');
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function(body) {
      var meta = this.__umNestedGuard || {};
      if (isLegacyIoChildAddRequest(meta.url, body)) {
        logDebug('Blocked legacy IO child add (xhr reroute).', { url: meta.url, body: bodyToText(body) });
        emitNestedStatus('blocked_legacy_io_child_add', { transport: 'xhr', url: meta.url });
        // Reroute to cart.js so caller receives a successful JSON response and does not retry add-on writes.
        originalOpen.call(this, 'GET', (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js', true);
        return originalSend.call(this, null);
      }
      return originalSend.apply(this, arguments);
    };
  }

  function handleize(value) {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/&/g, ' and ')
      .replace(/['"]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function parseJsonSafe(raw, fallback) {
    try {
      return JSON.parse(raw);
    } catch (_) {
      return fallback;
    }
  }

  function normalizeAddonConfig(rawConfig) {
    var source = rawConfig && rawConfig.options ? rawConfig.options : rawConfig;
    var normalized = {};
    if (!source || typeof source !== 'object') return normalized;

    Object.keys(source).forEach(function(rawPropertyKey) {
      var optionMap = source[rawPropertyKey];
      if (!optionMap || typeof optionMap !== 'object') return;

      var propertyKey = handleize(rawPropertyKey);
      if (!propertyKey) return;

      normalized[propertyKey] = normalized[propertyKey] || {};

      Object.keys(optionMap).forEach(function(rawOptionKey) {
        var entry = optionMap[rawOptionKey];
        if (!entry || typeof entry !== 'object') return;

        var productHandle = handleize(entry.productHandle || entry.handle || '');
        var optionKey = handleize(rawOptionKey);
        if (!optionKey || !productHandle) return;

        normalized[propertyKey][optionKey] = {
          label: String(entry.label || rawPropertyKey || '').trim(),
          productHandle: productHandle
        };
      });
    });

    return normalized;
  }

  installLegacyIoWriterGuard();

  function getParentLineProperties(formData) {
    var props = {};
    formData.forEach(function(value, key) {
      var match = String(key || '').match(/^properties\[(.+)\]$/);
      if (!match) return;
      props[match[1]] = String(value == null ? '' : value);
    });
    return props;
  }

  function getAddonSelectionsFromProperties(properties, addonConfig) {
    var selections = [];
    Object.keys(properties).forEach(function(rawKey) {
      var rawValue = properties[rawKey];
      if (rawValue == null || String(rawValue).trim() === '') return;
      if (String(rawKey).charAt(0) === '_') return;

      var propertyKey = handleize(rawKey);
      var optionMap = addonConfig[propertyKey];
      if (!optionMap) return;

      var optionKey = handleize(rawValue);
      var entry = optionMap[optionKey];
      if (!entry && (optionKey === 'yes' || optionKey === 'true' || optionKey === '1')) {
        entry = optionMap.yes;
      }
      if (!entry || !entry.productHandle) return;

      var dedupeKey = entry.productHandle;
      if (selections.some(function(item) { return item.productHandle === dedupeKey; })) return;

      selections.push({
        propertyKey: rawKey,
        propertyValue: String(rawValue),
        label: entry.label || rawKey,
        productHandle: entry.productHandle
      });
    });
    return selections;
  }

  function inferAddonType(selection) {
    var h = handleize(selection && selection.productHandle ? selection.productHandle : '');
    if (h.indexOf('artist-border') !== -1) return 'artist_border';
    if (h.indexOf('personalisation') !== -1) return 'personalisation';
    if (h.indexOf('hypsometric-3d') !== -1) return 'hypsometric_3d';
    if (h.indexOf('unique-3d') !== -1) return 'unique_3d';
    if (h.indexOf('aged') !== -1) return 'aged';
    if (h.indexOf('hanger') !== -1) return 'hanger';
    return h || 'addon';
  }

  function resolveAddonVariantIdByHandle(handle) {
    var normalizedHandle = handleize(handle);
    if (!normalizedHandle) return Promise.resolve(null);

    if (productCacheByHandle.has(normalizedHandle)) {
      return productCacheByHandle.get(normalizedHandle);
    }

    var req = fetch('/products/' + encodeURIComponent(normalizedHandle) + '.js', {
      credentials: 'same-origin'
    })
      .then(function(response) {
        if (!response.ok) throw new Error('Failed to load product ' + normalizedHandle);
        return response.json();
      })
      .then(function(productJson) {
        var variants = productJson && Array.isArray(productJson.variants) ? productJson.variants : [];
        var preferred = variants.find(function(v) { return !!v && !!v.available; }) || variants[0];
        return preferred && preferred.id ? Number(preferred.id) : null;
      })
      .catch(function() {
        return null;
      });

    productCacheByHandle.set(normalizedHandle, req);
    return req;
  }

  function buildFormFallbackPayload(formData) {
    var params = new URLSearchParams();
    formData.forEach(function(value, key) {
      params.append(key, value);
    });
    return params.toString();
  }

  function delay(ms) {
    return new Promise(function(resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  async function cleanupDuplicateAddonLines(parentVariantId, configId, addonVariantIds) {
    if (!Number.isFinite(parentVariantId) || !configId || !Array.isArray(addonVariantIds) || !addonVariantIds.length) return;
    await delay(900);

    var cartResponse = await fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    });
    if (!cartResponse.ok) return;
    var cart = await cartResponse.json().catch(function() { return null; });
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    if (!items.length) return;

    var parentKeys = items
      .filter(function(item) {
        var props = item && item.properties && typeof item.properties === 'object' ? item.properties : {};
        return Number(item && item.variant_id) === Number(parentVariantId) && String(props._config_id || '') === String(configId);
      })
      .map(function(item) { return String(item.key || ''); })
      .filter(Boolean);
    if (!parentKeys.length) return;

    var changes = {};

    addonVariantIds.forEach(function(variantId) {
      var vid = Number(variantId);
      if (!Number.isFinite(vid) || vid <= 0) return;

      var nestedMatches = items.filter(function(item) {
        var rel = item && item.parent_relationship ? item.parent_relationship : null;
        var parentKey = rel && rel.parent_key ? String(rel.parent_key) : '';
        return Number(item && item.variant_id) === vid && parentKey && parentKeys.indexOf(parentKey) !== -1;
      });
      if (!nestedMatches.length) return;

      var nonNestedMatches = items.filter(function(item) {
        var rel = item && item.parent_relationship ? item.parent_relationship : null;
        var parentKey = rel && rel.parent_key ? String(rel.parent_key) : '';
        return Number(item && item.variant_id) === vid && !parentKey;
      });
      if (!nonNestedMatches.length) return;

      // Keep the nested lines; remove same-count non-nested duplicates.
      var removeCount = Math.min(nonNestedMatches.length, nestedMatches.length);
      for (var i = 0; i < removeCount; i += 1) {
        var lineKey = String(nonNestedMatches[i] && nonNestedMatches[i].key ? nonNestedMatches[i].key : '');
        if (!lineKey) continue;
        changes[lineKey] = 0;
      }
    });

    var changeKeys = Object.keys(changes);
    if (!changeKeys.length) return;

    logDebug('Duplicate non-nested add-ons detected; applying cleanup.', {
      parentVariantId: parentVariantId,
      configId: configId,
      changes: changes
    });

    await Promise.all(changeKeys.map(function(lineKey) {
      return fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      }).catch(function() { return null; });
    }));
  }

  async function onSubmit(event) {
    if (interceptLock) return;

    var form = event.target && event.target.closest ? event.target.closest('form[action*="/cart/add"]') : null;
    if (!form) return;
    if (form.hasAttribute('data-um-nested-intercept-bypass')) return;

    var formData = new FormData(form);
    var parentVariantId = Number(formData.get('id'));
    if (!Number.isFinite(parentVariantId) || parentVariantId <= 0) return;

    var parentQuantity = Number(formData.get('quantity'));
    if (!Number.isFinite(parentQuantity) || parentQuantity <= 0) parentQuantity = 1;

    var addonConfig = normalizeAddonConfig(parseJsonSafe(addonConfigEl.textContent || '{}', {}));
    if (!Object.keys(addonConfig).length) return;

    var parentProperties = getParentLineProperties(formData);
    var selectedAddons = getAddonSelectionsFromProperties(parentProperties, addonConfig);
    if (!selectedAddons.length) {
      logDebug('No mapped add-ons detected. Native add-to-cart used.');
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    interceptLock = true;

    try {
      // Safe mode: only intercept when every selected add-on can be resolved.
      var resolved = await Promise.all(selectedAddons.map(function(addon) {
        return resolveAddonVariantIdByHandle(addon.productHandle).then(function(variantId) {
          return { addon: addon, variantId: variantId };
        });
      }));
      if (resolved.some(function(entry) { return !Number.isFinite(entry.variantId) || entry.variantId <= 0; })) {
        logDebug('Mapped add-ons found, but at least one variant ID could not be resolved. Using controlled native fallback.', resolved);
        emitNestedStatus('resolve_failed', { parentVariantId: parentVariantId, selectedAddons: selectedAddons.map(function(a){ return a.productHandle; }) });
        throw new Error('Could not resolve one or more add-on variant IDs');
      }

      var configId = parentProperties._config_id || (
        (window.crypto && typeof window.crypto.randomUUID === 'function')
          ? window.crypto.randomUUID()
          : ('cfg_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10))
      );
      parentProperties._config_id = configId;

      var items = [{
        id: parentVariantId,
        quantity: parentQuantity,
        properties: parentProperties
      }];

      var sellingPlan = formData.get('selling_plan');
      if (sellingPlan != null && String(sellingPlan).trim() !== '') {
        items[0].selling_plan = String(sellingPlan).trim();
      }

      resolved.forEach(function(entry) {
        var addon = entry.addon;
        items.push({
          id: entry.variantId,
          quantity: parentQuantity,
          parent_id: parentVariantId,
          properties: {
            'Add-on': addon.label,
            '_config_id': configId,
            '_addon_type': inferAddonType(addon)
          }
        });
      });

      logDebug('Intercepting add-to-cart with nested payload.', {
        parentVariantId: parentVariantId,
        parentQuantity: parentQuantity,
        addOnCount: resolved.length,
        addOns: resolved.map(function(entry) {
          return {
            handle: entry.addon.productHandle,
            variantId: entry.variantId,
            type: inferAddonType(entry.addon)
          };
        })
      });

      var response = await fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: items })
      });

      if (!response.ok) {
        emitNestedStatus('nested_request_http_error', { status: response.status || 0, parentVariantId: parentVariantId });
        throw new Error('Nested add failed');
      }

      var responseJson = await response.json().catch(function() { return null; });
      var responseItems = responseJson && Array.isArray(responseJson.items) ? responseJson.items : [];
      var nestedCount = responseItems.filter(function(item) {
        return !!(item && (item.parent_relationship || item.parentRelationship));
      }).length;
      logDebug('Nested add response received.', {
        returnedItems: responseItems.length,
        nestedItems: nestedCount,
        looksNested: nestedCount > 0,
        response: responseJson
      });
      emitNestedStatus('success', {
        parentVariantId: parentVariantId,
        addOnCount: resolved.length,
        nestedItems: nestedCount,
        looksNested: nestedCount > 0
      });

      var addonVariantIds = resolved.map(function(entry) { return Number(entry.variantId); }).filter(function(v) {
        return Number.isFinite(v) && v > 0;
      });
      cleanupDuplicateAddonLines(parentVariantId, configId, addonVariantIds).catch(function() { return null; });

      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          product: { id: parentVariantId },
          qty: parentQuantity
        }
      }));
    } catch (_) {
      logDebug('Nested add failed, falling back to native add-to-cart.');
      emitNestedStatus('fallback_started', { parentVariantId: parentVariantId });
      // Hard fallback to native add path for resilience.
      try {
        form.setAttribute('data-um-nested-intercept-bypass', '1');
        await fetch((window.theme && theme.routes && theme.routes.cartAdd) ? theme.routes.cartAdd : '/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: buildFormFallbackPayload(formData)
        });
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: { id: parentVariantId },
            qty: parentQuantity
          }
        }));
        logDebug('Fallback native add succeeded.');
        emitNestedStatus('fallback_success', { parentVariantId: parentVariantId });
      } catch (_) {
        logDebug('Fallback native add failed; submitting form directly.');
        emitNestedStatus('fallback_submit_direct', { parentVariantId: parentVariantId });
        form.submit();
      } finally {
        form.removeAttribute('data-um-nested-intercept-bypass');
      }
    } finally {
      interceptLock = false;
    }
  }

  document.addEventListener('submit', function(event) {
    var form = event.target && event.target.closest ? event.target.closest('form[action*="/cart/add"]') : null;
    if (!form) return;
    onSubmit(event);
  }, true);
})();
